export const HomeFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.075 14.375h-.625v8H3.325V7.354L12.7 1.729l9.375 5.625v15.021H13.95v-8h-1.875"
    ></path>
    <path
      stroke="currentColor"
      strokeWidth="1.25"
      d="M12.075 14.375h-.625v8H3.325V7.354L12.7 1.729l9.375 5.625v15.021H13.95v-8h-1.875Z"
    ></path>
  </svg>
);
